import styled from 'styled-components';
import React from 'react';

// eslint-disable-next-line jsx-a11y/anchor-has-content
export const StyledAnchor = styled(({ external, ...props }) => <a {...props} />)`
  position: relative;
  display: flex;
  text-decoration: none;
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.black};
  border: 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray3};
  border-left: 3px solid ${({ theme }) => theme.colors.white};
  background: ${({ theme }) => theme.colors.white};
  padding: 15px 16px;
  outline: none;
  line-height: 1.29;
  box-sizing: border-box;
  // When the link is actually a button
  width: 100%;
  text-align: left;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.blue12};
    color: ${({ theme }) => theme.colors.blue5};
    border-left: 3px solid ${({ theme }) => theme.colors.blue12};
  }

  &.active:not(:disabled) {
    border-left: 3px solid ${({ theme }) => theme.colors.blue5};
    color: ${({ theme }) => theme.colors.blue5};
  }

  &:active:not(:disabled) {
    background: ${({ theme }) => theme.colors.blue14};
    color: ${({ theme }) => theme.colors.blue10};
    border-left: 3px solid ${({ theme }) => theme.colors.blue14};
  }
  &:active:not(:disabled).active {
    border-left: 3px solid ${({ theme }) => theme.colors.blue5};
  }
`;

export const StyledAnchorText = styled.span`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  padding-right: 8px;
`;
